import angular from 'angular'
import RFPManagerRepository from 'root/rfp/rfp-manager/main/rfp.rfp-manager.repo';
import RbRfpManagerCompanies from './ui/rfp-manager-companies/rfp-manager-companies.cmp';

export default angular.module('rb.rfp.rfpManager.main', [])
  .service('rfpManagerRepository', RFPManagerRepository)
  .component('rbRfpManagerCompanies', RbRfpManagerCompanies)


